import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API, SCAMP_API_RPT } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { RetornoApi } from '../models/retornoApi.model';

@Injectable({providedIn: 'root'})
export class RdService {
  constructor(
    private http: HttpClient,
    private account: AccountService
  ) { }

  urlBase = `${SCAMP_API.accountApiV1}/rds`;

  add(data: any) {
    return this.http.post(`${SCAMP_API.accountApiV1}/rds`, data,
      { headers: this.account.composeHeaders() });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${SCAMP_API.accountApiV1}/rds/${id}`,
      { headers: this.account.composeHeaders() });
  }

  getByDataAndModeloRD(data, rdModeloId): Observable<any> {
    return this.http.get<any>(`${SCAMP_API.accountApiV1}/rds/by-data-modelrd/${data}/${rdModeloId}`,
      { headers: this.account.composeHeaders() });
  }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/rds`,
      { headers: this.account.composeHeaders() });
  }

/*   getAllPromise(): Promise<Response> {

   return fetch(this.urlBase, {
      method: 'GET', 
      headers: this.account.getHearderAuthorization()
    })

  } */


  
  getNextRdNumeroSeq(data): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/rds/next-rdnumeroseq/${data}`,
      { headers: this.account.composeHeaders() });
  }

  getByIntervalAsync(dataInicio, dataTermino): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/rds/por-interval/${dataInicio}/${dataTermino}`,
      { headers: this.account.composeHeaders() });
  }

   
  getByIntervalPromise(dataInicio, dataTermino): Promise<Response> {

    return fetch(`${this.urlBase}/por-interval/${dataInicio}/${dataTermino}`,
    {
      method: 'GET',
      headers: this.account.getHearderAuthorization()
    })
  }



  imprimirRD(rdId: number): Observable<RetornoApi> {
    return this.http.get<RetornoApi>(`${SCAMP_API_RPT.accountApiV1}/rds/${rdId}`);
  }

  isUniqueDataRdModeloId(data: string, rdModeloId: number, id: number): Observable<boolean> {
    return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/rds/is-unique-rddata-rdmodeloid`, { data, fkId: rdModeloId, id },
      { headers: this.account.composeHeaders() });
  }

  isUniqueDataRdModeloIdPromise(data: string, rdModeloId: number, id: number): Promise<Response> {
    var formdata = new FormData();
    formdata.append("data", data);
    formdata.append("fkId", String(rdModeloId));
    formdata.append("id", String(id));

    return fetch(`${this.urlBase}/is-unique-rddata-rdmodeloid`, {
      method: 'POST',
      headers: this.account.getHearderAuthorization(),
      body: formdata
    })
  }

  getNextRdNumeroSeqPromise(data): Promise<Response> {

    return fetch(`${SCAMP_API.accountApiV1}/rds/next-rdnumeroseq/${data}`, {
      method: 'GET',
      headers: {
        "Authorization": this.account.composeHeaders().keys["Authorization"]
      }
    } )
  }

}

